import apiClient from "./api";

export interface SuspendItem {
  product_id: number;
  product_code: string;
  product_name: string;
  unit_price: number;
  quantity: number;
  warehouse_id: number;
  subtotal: number;
  [key: string]: any;
}

export interface SuspendData {
  id?: number;
  user_id: number;
  reference_no: string;
  total: number;
  total_discount?: number;
  payments_cash?: number;
  payments_bank?: number;
  status?: string;
  note?: string;
  items: SuspendItem[];
  [key: string]: any;
}

const API_URL = "/pos-suspends";

export default {
  async getSuspends() {
    const res = await apiClient.get(API_URL);
    return res.data;
  },

  async getSuspend(id: number) {
    const res = await apiClient.get(`${API_URL}/${id}`);
    return res.data;
  },

  async createSuspend(data: SuspendData) {
    const res = await apiClient.post(API_URL, data);
    return res.data;
  },

  async deleteSuspend(id: number) {
    const res = await apiClient.delete(`${API_URL}/${id}`);
    return res.data;
  },

  async updateSuspend(id: number, data: SuspendData) {
    const res = await apiClient.put(`${API_URL}/${id}`, data);
    return res.data;
  }
};
